<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row v-if="form_data != null && classifiers_loaded && members_loaded">
        <v-col>
            <div v-if="selectedAccount && selectedAccount.is_demo && !clientId">
                <div class="d-flex mb-3 pl-12">
                    <v-img
                        class="mt-2"
                        max-width="185"
                        max-height="80"
                        :src="require('@/assets/demo-warning-arrow.svg')"
                    />
                    <div>
                        <div class="title error--text mb-1">
                            {{ $t('Are you sure?') }}
                        </div>
                        <span class="body-1" v-html="demoWarningText"/> <!-- INPUT FROM STATIC TRANSLATION -->
                    </div>
                </div>
            </div>
            <EditForm
                :account-id="account_id"
                related-type="client"
                :related-id="clientId"
                :instance-data="form_data"
                :outer-scope-fields="['name', 'client_initials', 'color', 'address_country_code', 'members', 'topic_required', 'timing_required']"
                :save-button-title="form_data.id ? $t('Save') : $t('Continue')"
                :changes="form_data_changes"
                edit-form-test-prefix="client_edit"
                @handle_error_response="onErrorResponse"
                @clear_validation_errors="onClearErrors"
                @close="closeForm"
                @update-dirty="hasDirtyGroups = $event"
                @field_changed="onFieldChanged"
            >
                <template v-slot:header>
                    <div
                        v-if="client"
                        class="title"
                    >
                        {{ $t('Edit client') }}
                    </div>
                    <div
                        v-else
                        class="title"
                    >
                        <span>{{ selectedAccount.name }}</span>
                        <span class="mx-3">›</span>
                        <span>{{ $t('Add client') }}</span>
                    </div>
                </template>
                <template v-slot:my-company="{ item }">
                    <!-- Name. Initials, Color and Country -->
                    <v-row class="px-1">
                        <v-col class="col-lg-5 col-md-4 col-sm-12 col-12 px-2 py-0">
                            <v-combobox
                                :value="form_data.name"
                                :label="$t('Company\'s name') + ' *'"
                                :items="companies_suggestions.results"
                                :loading="companies_loading"
                                :search-input.sync="companies_search"
                                hide-no-data
                                item-text="name"
                                item-value="name"
                                test-id="client_edit_autosuggest"
                                append-icon="search"
                                no-filter
                                return-object
                                :error-messages="form_data.name_error"
                                :menu-props="{attach: true}"
                                outlined
                                @keyup="nameChanged($event, item)"
                                @change="company_selected($event, item)"
                            ></v-combobox>
                        </v-col>
                        <v-col class="col-lg-3 col-md-4 col-sm-6 col-12 px-2 py-0">
                            <div style="width: 50%; float: left;" class="pr-2">
                                <v-text-field
                                    v-model="form_data.client_initials"
                                    :label="$t('Mark') + ' *'"
                                    :error-messages="form_data.client_initials_error"
                                    outlined
                                    test-id="client_edit_initials"
                                    @change="initials_changed"
                                    @input="initials_input($event, item)"
                                ></v-text-field>
                            </div>
                            <div style="width: 50%; float: left;" class="pl-2">
                                <v-select
                                    v-model="form_data.color"
                                    :label="$t('Color') + ' *'"
                                    :items="colors"
                                    class="uku-color-picker"
                                    outlined
                                    :menu-props="{
                                        offsetY: true,
                                        contentClass: 'uku-color-picker-menu',
                                        auto: true
                                    }"
                                    :error-messages="form_data.color_error"
                                    @change="item.is_dirty = true;"
                                >
                                    <template v-slot:selection="{}">
                                        <v-avatar
                                            :class="[form_data.color]"
                                            size="28"
                                            tile
                                            :style="{ 'borderRadius': '4px' }"
                                        >
                                            <span
                                                :class="[
                                                    'white--text',
                                                    form_data.client_initials != null &&
                                                        form_data.client_initials.length > 2
                                                        ? 'caption'
                                                        : 'body-2'
                                                ]"
                                            >{{ client_initials_f }}</span>
                                        </v-avatar>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-avatar
                                            :class="[item]"
                                            size="32"
                                            tile
                                            :style="{ 'borderRadius': '4px' }"
                                        ></v-avatar>
                                    </template>
                                </v-select>
                            </div>
                        </v-col>
                        <v-col class="col-lg-4 col-md-4 col-sm-6 col-12 px-2 py-0">
                            <v-row no-gutters>
                                <v-select
                                    v-model="form_data.address_country_code"
                                    :label="$t('Country') + ' *'"
                                    :items="countries"
                                    item-text="name"
                                    item-value="code"
                                    test-id="client_edit_country"
                                    outlined
                                    hide-details
                                    :menu-props="{ offsetY: true }"
                                    :error-messages="form_data.address_country_code_error"
                                    @change="item.is_dirty = true"
                                ></v-select>
                            </v-row>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:members="{ item }">
                    <v-dialog v-model="item.isShowAddVisible" persistent max-width="540">
                        <v-card>
                            <v-card-title class="headline">{{ $t("Add members") }}</v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col>
                                        <div class="subtitle-2">{{ $t("Members and groups") }}</div>
                                        <v-autocomplete
                                            v-model="add_members_data"
                                            :items="account_members.available"
                                            item-text="name"
                                            item-value="person_id"
                                            solo
                                            multiple
                                            :menu-props="{ offsetY: true }"
                                            @change="item.is_dirty = true"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn text @click="item.isShowAddVisible = false">
                                    {{ $t("Cancel") }}
                                </v-btn>
                                <v-btn class="primary inverted--text" @click="add_members_click(item)">
                                    {{ $t("Add") }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <data-table
                        :items="form_data.members"
                        :headers="membersHeaders"
                    >
                        <template v-slot:item.name="{ item: account_member }">
                            <AccountChip
                                :account="account_member"
                                :show-is-primary="true"
                                :is-primary="form_data.default_person_id === account_member.person_id"
                                :base-url="baseUrl"
                                @set_primary="set_default_person($event, item)"
                            ></AccountChip>
                        </template>
                        <template v-slot:item.clientPortal="{ item: account_member }">
                            <switch-button
                                v-if="account_member.type !== 'group'"
                                :value="account_member.is_cp || account_member.person_id === form_data.default_person_id"
                                :disabled="account_member.person_id === form_data.default_person_id"
                                @change="account_member.is_cp = $event ? 1 : 0; item.is_dirty = true"
                            />
                        </template>
                        <template v-slot:item.rights="{ item: account_member }">
                            <div v-if="account_member.editable" class="d-flex align-center py-1">
                                <v-select
                                    v-model="account_member.granted_role"
                                    outlined
                                    class="mt-0 pt-0 mb-0"
                                    :hide-details="!account_member.granted_role_error"
                                    :items="roles"
                                    item-text="title"
                                    item-value="name"
                                    :error-messages="account_member.granted_role_error"
                                    :menu-props="{ offsetY: true }"
                                    @change="item.is_dirty = true"
                                ></v-select>
                            </div>
                            <span v-else style="line-height: 44px;" class="subtitle-1 pl-3">
                                {{ format_role(account_member.role) }}
                            </span>
                        </template>
                        <template v-slot:item.actions="{ item: account_member }">
                            <icon-button
                                v-if="account_member.editable"
                                icon="Trash2"
                                @click="remove_permissions(account_member); item.is_dirty = true"
                            />
                        </template>
                    </data-table>
                </template>
                <template v-slot:preferences="{ item }">
                    <v-row>
                        <v-col class="col-12">
                            <v-switch
                                v-model="form_data.topic_required"
                                class="mt-0"
                                color="primary"
                                :label="$t('Topic is required')"
                                :error-messages="form_data.topic_required_error"
                                :hide-details="!form_data.topic_required_error"
                                @change="preferencesSelectChange('topic_required', $event, item)"
                            ></v-switch>
                        </v-col>
                        <v-col class="col-12">
                            <v-switch
                                v-model="form_data.timing_required"
                                class="mt-0"
                                color="primary"
                                :label="$t('Entering time is required')"
                                :error-messages="form_data.timing_required_error"
                                :hide-details="!form_data.timing_required_error"
                                @change="preferencesSelectChange('timing_required', $event, item)"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:buttons-left>
                    <v-btn
                        v-if="
                            form_data.id &&
                                !form_data.is_account &&
                                (form_data.rights & DELETE_CLIENT) === DELETE_CLIENT
                        "
                        color="error"
                        text
                        @click="delete_client"
                    >
                        {{ $t("Delete client") }}
                    </v-btn>
                    <secondary-button
                        v-if="selectedAccount.id !== current_account.id"
                        color="primary"
                        @click="onOpenAppStore"
                    >
                        {{ $t('Manage client fields') }}
                    </secondary-button>
                </template>
            </EditForm>
        </v-col>
    </v-row>
</template>

<script>
import Vue from "vue";
import {computed, onMounted, reactive, ref, watch} from "@vue/composition-api";
import {$t} from "@/i18n";
import {Router} from "@/composables/Router";
import AccountModule from "../../../store/modules/account";
import ClientModule from "../../../store/modules/client";
import AppModule, {state as appState} from "../../../store/modules/app";
import AccountChip from "../../../components/AccountChip";
import DialogModule from "../../../store/modules/dialog";
import RightsModule from "@/composables/use-rights";
import CustomField from "../../../components/CustomField.vue";
import EditForm from "../../../components/CustomForm/EditForm";
import ComboboxDropdown from "../../../components/ComboboxDropdown";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {APP_STORE_APP_TYPES, CUSTOM_FIELD_RELATED_TYPE} from "@/helpers/constants";
import CustomFieldEditDialog from "@/components/Dialog/CustomFieldEditDialog/Index";
import BreadcrumbsModule from "@/store/modules/breadcrumbs";
import appStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";

export default {
    name: "ClientEditView",
    components: {
        AccountChip,
        CustomField,
        EditForm,
        ComboboxDropdown,
        CustomFieldEditDialog
    },
    setup(props, ctx) {
        const {setPageTitle, isNavigationWarning} = AppModule();
        const {can_edit_account: can_edit_account_check} = RightsModule();
        const router = Router();
        const appModule = AppModule();
        const {isFeatureEnabled, getMembers, current_account, getAccount} = AccountModule();
        const {setBreadcrumbs} = BreadcrumbsModule();
        const clientModule = ClientModule();
        const {openConfirmDialog, setConfirmOptions} = DialogModule();
        const hasDirtyGroups = ref(false);
        const DELETE_CLIENT = appModule.rights_masks.value.delete_client;
        const {appStoreDialogActions} = appStoreDialog()

        const dialogModule = DialogModule();

        // form data

        let form_data_struct = {
            id: "integer",
            name: "text",
            client_initials: "text",
            address_country_code: "text",
            color: "text",
            timing_required: "boolean",
            topic_required: "boolean",
            default_person_id: "number",
            members: "list",
            rights: "integer",
            fields: "object"
        };
        const pristine_client_status = ref(null);

        const account_members = reactive({available: []});
        const form_data = ref(null);
        const form_data_changes = ref(null);
        const classifiers_loaded = ref(false);
        const members_loaded = ref(false);
        const client = ref(null);
        const colors = (function () {
            let ret = [];
            for (let i = 1; i <= 48; i++) {
                ret.push("color-{0}".format(i));
            }
            return ret;
        })();
        const account_id = computed(function () {
            if (router.currentRoute.name === "client_new") {
                return parseInt(router.currentRoute.params.account_id);
            } else {
                return form_data.value ? form_data.value.account_id : null;
            }
        });

        const selectedAccount = computed(() => {
            return getAccount(account_id.value).value
        })

        const clientId = computed(() => {
            return parseInt(router.currentRoute.params.id);
        });

        onMounted(async () => {
            try {
                if (clientId.value) {
                    client.value = await clientModule.fetchClient({client_id: clientId.value})
                }
            } catch (e) {
                errorDialog.showError(e)
            }

            if (client.value) {
                setBreadcrumbs([
                    {
                        to: {
                            name: 'clients_list',
                        },
                        name: $t('Clients')
                    },
                    {
                        to: {
                            name: 'client_profile_overview',
                            params: {
                                id: clientId.value,
                            }
                        },
                        name: client.value.name
                    }
                ], ctx.root._route.name)
            } else {
                await Vue.nextTick()
                setBreadcrumbs([
                    {
                        to: {
                            name: 'clients_list',
                        },
                        name: $t('Clients')
                    },
                    {
                        name: $t('Add client')
                    }
                ], ctx.root._route.name)
            }
        })

        const countries = computed(function () {
            return appModule.countries.value;
        });
        const client_initials_f = computed(function () {
            if (form_data.value.client_initials && form_data.value.client_initials.length > 3) {
                return form_data.value.client_initials.substr(0, 3);
            }
            return form_data.value.client_initials;
        });
        const page_title = computed(function () {
            if (!selectedAccount.value) {
                return ''
            }

            const companyName = selectedAccount.value.name
            const clientName = router.currentRoute.name === "client_edit" && client.value ? client.value.name : $t("New client")

            return `${companyName} > ${clientName}`
        });
        const can_edit_account = computed(function () {
            return can_edit_account_check(account_id.value);
        });
        const clientPortalEnabled = computed(() => {
            return isFeatureEnabled(account_id.value, "client_portal", false);
        });

        const load_classifiers = async function () {
            appModule
                .fetchClassifiers({
                    types: ["countries", "languages", "client_groups", "roles", "taxes"],
                    account_id: account_id.value,
                    force: {default: true, types: ["custom_fields"]}
                })
                .then(() => {
                    classifiers_loaded.value = true;
                })
                .catch(ex => errorDialog.showError(ex));

            let add_me = router.currentRoute.name === "client_new";

            getMembers({account_id: account_id.value, include_groups: 1, person_status: 'visible', itemsPerPage: 9999})
                .then(function (resp) {
                    resp.users.forEach(function (x) {
                        if (x.status !== "active" && x.status !== "pending" && x.status !== 'limited') return;

                        x.granted_role_error = null;

                        let found = false;
                        for (let i in form_data.value.members) {
                            if (form_data.value.members[i].person_id === x.person_id) {
                                x.granted_role =
                                    form_data.value.members[i].role === "no_role"
                                        ? null
                                        : form_data.value.members[i].role;
                                x.editable = x.direct_role !== "admin" && x.direct_role !== "owner";
                                x.is_cp = form_data.value.members[i].is_cp;
                                form_data.value.members[i] = x;
                                found = true;
                            }
                        }

                        if (found) return;

                        if (
                            x.direct_role === "admin" ||
                            x.direct_role === "owner" ||
                            (x.person_id === current_account.value.id && add_me)
                        ) {
                            x.granted_role = x.direct_role === "no_role" ? null : x.direct_role;
                            x.editable = x.direct_role !== "admin" && x.direct_role !== "owner";
                            if (x.person_id === current_account.value.id) {
                                if (x.granted_role == null || x.granted_role !== "owner") {
                                    x.granted_role = "admin";
                                }

                                if (!form_data.value.default_person_id) {
                                    form_data.value.default_person_id = x.person_id;
                                }
                            }
                            x.is_cp = false
                            form_data.value.members.push(x);
                        } else {
                            x.granted_role = null;
                            x.editable = true;
                            account_members.available.push(x);
                        }
                    });
                    members_loaded.value = true;
                })
                .catch(function (ex) {
                    errorDialog.showError(ex);
                });
        };

        if (router.currentRoute.name === "client_edit") {
            let client_id = parseInt(router.currentRoute.params.id);
            clientModule
                .fetchClient({client_id, for_edit: 1, include_emails: 1})
                .then((resp) => {
                    setPageTitle(`${$t('Edit client')} - ${$t(resp.name)}`);
                    form_data.value = Vue.prepare_form_data(resp, form_data_struct);
                    pristine_client_status.value = resp.status;
                    load_classifiers();
                })
                .catch(ex => errorDialog.showError(ex));
        } else {
            form_data.value = Vue.prepare_form_data(
                {
                    type: "client",
                    status: "active",
                    account_id: parseInt(router.currentRoute.params.account_id),
                    address_country_code: current_account.value.address_country_code,
                    locale_code: current_account.value.locale_code,
                    color: "color-{0}".format(Math.floor(Math.random() * 48 + 1)),
                    timing_required: false,
                    topic_required: false,
                    groups: [],
                    contacts: [],
                    members: [],
                },
                form_data_struct
            );

            load_classifiers();
        }

        const searchValue = ref()
        const nameChanged = (e, group) => {
            // prevent double searches with same name, after a keypress that doesn't change the value, such as "Ctrl", etc.
            // note that the check is before trimming - this is on purpose, otherwise hitting space won't trigger search
            if (searchValue.value && e.target.value === searchValue.value) return
            let name = e.target.value.trim();
            if (!name
                || name.length < 3
                || !companies_search.value
                || !form_data.value.address_country_code
                || !["ee", "gb", "dk", "no"].includes(form_data.value.address_country_code)
            ) {
                companies_suggestions.results = [];
            } else {
                searchValue.value = name
                setTimeout(function () {
                    // delay actual search query, because user is still typing
                    if (name && name === companies_search.value.trim()) {
                        companies_suggestions.results = [];
                        clientModule
                            .companyAutocomplete({keyword: encodeURIComponent(name), country_code: form_data.value.address_country_code})
                            .then(function (resp) {
                                if (name === companies_search.value.trim()) {
                                    companies_suggestions.results = resp.results;
                                }
                            })
                            .catch(function (ex) {
                                errorDialog.showError(ex);
                            });
                    } else {
                        companies_suggestions.results = [];
                    }
                }, 1000);
            }

            form_data.value.name = name
            if (name) form_data.value.client_initials = name.charAt(0).toUpperCase();
            group.is_dirty = true;
        }

        const company_selected = async function (data, group) {

            if (typeof data == "object") {
                // prevent selecting item from dropdown from triggering another autocomplete search
                searchValue.value = data.name
                if (data.country_code === "gb") {
                    let response = await clientModule.companyExtraInfo({country_code: "gb", reg_no: data.reg_no})
                    data = response.result
                }

                form_data.value.name = data.name;
                let name = form_data.value.name.trim();
                if (name) form_data.value.client_initials = name.charAt(0).toUpperCase();

                form_data_changes.value = {
                    name: form_data.value.name,
                    client_initials: form_data.value.client_initials,
                    reg_code: data.reg_no,
                    vat_code: data.eu_vat_no,
                    address_street: data.address,
                    address_city: data.city,
                    address_zip: data.zip_code,
                    address_state: data.county,
                    contacts: data.contacts ? data.contacts.map(x => {
                        x.tmp_id = 'ch-' + data.contacts.indexOf(x)
                        x.is_newly_added = true
                        return x
                    }) : data.contacts,
                    // fixme :: todo :: make these constants
                    ch_company_type: data.ch_company_type,
                    ch_company_status: data.ch_company_status,
                    ch_date_of_creation: data.ch_date_of_creation,
                    ch_can_file: data.ch_can_file,
                    ch_has_insolvency_history: data.ch_has_insolvency_history,
                    ch_accounts_made_up_to: data.ch_accounts_made_up_to,
                    ch_accounts_next_due: data.ch_accounts_next_due,
                    ch_confirmation_statement_made_up_to: data.ch_confirmation_statement_made_up_to,
                    ch_confirmation_statement_next_due: data.ch_confirmation_statement_next_due,
                    ch_sic_codes: data.ch_sic_codes,
                };

                group.is_dirty = true
            }
        };

        const preferencesSelectChange = (field, value, group) => {
            form_data_changes.value = {
                [field]: value ? 1 : 0
            }

            group.is_dirty = true
        }

        const initials_changed = function (data) {
            form_data.value.client_initials = data.length > 3 ? data.substr(0, 3).toUpperCase() : data.toUpperCase();
            form_data.value.client_initials_error = null;
        };
        const initials_input = function (data, group) {
            form_data.value.client_initials_error = data.length > 3 ? $t("Max 3 characters") : null;
            group.is_dirty = true;
        };

        const delete_client_confirmed = function (e) {
            let params = {
                client_id: parseInt(router.currentRoute.params.id)
            };
            clientModule
                .deleteClient(params)
                .then(function () {
                    router.push({name: "clients_list"});
                })
                .catch(function (ex) {
                    errorDialog.showError(ex);
                });
        };
        const delete_client = function () {
            setConfirmOptions({
                title: $t("Are you sure you wish to delete this client?"),
                text: $t("Deleting client data will also delete all client-related tasks.<br/><br/>NB! Client history will be deleted"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: delete_client_confirmed
            });
            openConfirmDialog();
        };
        const closeForm = (resp) => {
            if (resp) {
                isNavigationWarning.value = false

                if (!form_data.value.id && resp.id) form_data.value.id = resp.id;

                if (router.currentRoute.name === "client_edit") {
                    router.push({name: "client_profile_overview", params: {id: router.currentRoute.params.id}});
                } else {
                    appModule.clearClassifiersCache("clients", form_data.value.account_id);
                    router.push({name: "client_edit_plan", params: {id: resp.id}});
                }
            } else {
                router.push({name: "clients_list"});
            }
        };
        const onErrorResponse = (ex) => {
            if (ex.response && ex.response.status) {
                if (ex.response.status === 400 && ex.response.data) {
                    if (ex.response.data.error_type === "form_validation") {
                        let validate_fields = ["name", "client_initials", "color", "address_country_code"];
                        appModule.setFieldErrors(form_data.value, ex.response.data.errors.filter(x => x.field && validate_fields.indexOf(x.field) >= 0));
                    }
                }
            }
        };
        const onClearErrors = () => {
            appModule.clearValidationErrors(form_data.value);
        };

        // /form data

        // members

        const add_members_data = ref([]);
        const remove_permissions = function (account_member) {
            for (var i in form_data.value.members) {
                if (form_data.value.members[i].person_id !== account_member.person_id) continue;
                form_data.value.members.splice(i, 1);
                break;
            }
            account_members.available.push(account_member);
        };
        const add_members_click = function (item) {
            // fix UP-56:
            // add_members_data.value = add_members_data.value.map(x => x.person_id);
            for (let i = account_members.available.length - 1; i >= 0; i--) {
                if (add_members_data.value.indexOf(account_members.available[i].person_id) >= 0) {
                    let account_member = account_members.available[i];
                    account_member.granted_role = "admin"; // "user";
                    form_data.value.members.push(account_member);
                    account_members.available.splice(i, 1);
                }
            }

            item.isShowAddVisible = false
            add_members_data.value = [];
        };
        const set_default_person = function (person_id, group) {
            form_data.value.default_person_id = person_id;
            form_data_changes.value = {
                default_person_id: person_id
            };

            if (isClientPortalAndClientSettingEnabled.value) {
                const person = form_data.value.members.find(x => x.person_id === person_id)
                person.is_cp = 1
            }

            group.is_dirty = true
        };
        const format_role = function (role) {
            switch (role) {
                case "owner":
                    return $t("Owner");
                case "admin":
                    return $t("Admin");
                case "user":
                    return $t("Member");
                default:
                    return "";
            }
        };
        const roles = reactive([
            {name: "admin", title: $t("Admin")},
            {name: "user", title: $t("Member")}
        ]);

        // /members

        // autocomplete

        const companies_suggestions = reactive({results: []});
        const companies_loading = ref(false);
        const companies_search = ref("");

        const demoWarningText = computed(() => {
            return `<div>${$t("All clients that you add under {0} will be deleted later.</div>").format(selectedAccount.value.name)}
             <div>${$t('Use this account for testing purposes only!')}
             <a href="/api/help_link/demo_account" target="_blank" style="color: var(--v-main-base); text-decoration: underline">${$t('Read more about the demo account')} ›</a>
              </div>
`
        })

        const openAppStore = () => {
            router.push({name: 'app_store', params: {accountId: selectedAccount.value.id}})

            appStoreDialogActions.openAppStoreModal(
                APP_STORE_APP_TYPES.CLIENTS,
                selectedAccount.value.id,
                {
                    onUpdate: () => {
                    },
                    dialogOptions: {defaultTab: 'clientCustomFields'},
                }
            )
        }

        const onOpenAppStore = () => {
            if (hasDirtyGroups.value) {
                dialogModule.setDialogOptions({
                    component: () => import("@/views/Dialog/NavigationWarningDialog"),
                    payload: {
                        type: "clients_plan",
                        title: $t("Leave page?"),
                        description: $t(
                            "Changes that you made may not be saved"
                        ),
                        cancelButton: $t("Cancel"),
                        confirmButton: $t("Leave"),
                        nextVal: () => {
                            openAppStore();
                        }
                    }
                });
            } else {
                openAppStore()
            }
        };

        const isClientPortalAndClientSettingEnabled = computed(() => {
            return isFeatureEnabled(account_id.value, "client_portal", false) && form_data.value.cp_is_active
        })

        const membersHeaders = computed(() => {
            let headers = [
                {
                    text: $t("Name"),
                    value: "name",
                    sortable: true,
                    width: '100%'
                }
            ]

            if (isClientPortalAndClientSettingEnabled.value) {
                headers.push({
                    text: $t("Client portal"),
                    value: "clientPortal",
                    sortable: false,
                })
            }

            headers.push({
                text: $t("Rights"),
                value: "rights",
                sortable: false,
                width: '250px'
            })

            headers.push({
                text: '',
                value: "actions",
                sortable: false,
                width: 0
            })

            return headers
        });

        const onFieldChanged = ({name, value}) => {
            if (name === 'cp_is_active') {
                const newFormData = {...form_data.value}
                newFormData.cp_is_active = value
                form_data.value = newFormData
            }
        }

        watch(() => hasDirtyGroups.value, () => {
            isNavigationWarning.value = Boolean(hasDirtyGroups.value)
        })

        // /autocomplete

        return {
            baseUrl: appModule.baseUrl,
            clientId,
            countries,
            colors,
            form_data,
            classifiers_loaded,
            members_loaded,
            account_members,
            companies_suggestions,
            companies_loading,
            companies_search,
            client_initials_f,
            page_title,
            roles,
            add_members_data,
            can_edit_account,
            account_id,
            clientPortalEnabled,
            DELETE_CLIENT,
            form_data_changes,
            company_selected,
            initials_changed,
            initials_input,
            remove_permissions,
            format_role,
            delete_client,
            set_default_person,
            add_members_click,
            closeForm,
            onErrorResponse,
            onClearErrors,
            preferencesSelectChange,
            nameChanged,
            CUSTOM_FIELD_RELATED_TYPE,
            selectedAccount,
            demoWarningText,
            client,
            onOpenAppStore,
            current_account,
            hasDirtyGroups,
            membersHeaders,
            isClientPortalAndClientSettingEnabled,
            onFieldChanged
        };
    }
};
</script>

<style lang="scss" scoped>
::v-deep .client-select-button {
    .disp {
        height: 40px;
        padding-top: 5px;

        .arrow {
            right: 5px;
            top: 7px;
        }

        .val {
            font-weight: normal !important;
        }
    }
}
</style>